import { ReactNode, HTMLProps, forwardRef } from 'react';
import UXButton from '@ux/button';
import '@ux/button/styles';
import Spinner from '@ux/spinner';

import '@ux/spinner/styles';
import useValidateEID from './hooks/useValidateEID';

export type ButtonProps = {
  active?: boolean;
  as?: 'cta' | 'select' | 'toggle' | 'external';
  className?: string;
  design?: 'critical' | 'inline' | 'primary' | 'secondary' | 'control' | 'stateless';
  download?: boolean | string;
  external?: boolean;
  hidden?: boolean;
  href?: string;
  icon?: ReactNode;
  size?: 'default' | 'small' | 'md';
  stretch?: boolean;
  text?: ReactNode;
  type?: 'button' | 'reset' | 'submit';
  'data-eid'?: string;
};

export type Props = Omit<HTMLProps<HTMLButtonElement>, 'size'> & ButtonProps & { isLoading?: boolean };

export default forwardRef<HTMLButtonElement, Props>(function Button(
  { icon, isLoading, disabled, ...rest }: Props,
  ref,
): JSX.Element {
  const { 'data-eid': dataEid } = rest;
  useValidateEID({ eid: dataEid });

  return (
    <UXButton
      {...rest}
      icon={isLoading === true ? <Spinner size='sm' data-testid='spinner' /> : icon}
      disabled={isLoading === true ? true : disabled}
      ref={ref}
    />
  );
});
